import React, { useEffect, useState } from 'react'
import Wrapper from '../../../../common/component/Wrapper';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { capitalizeFirstLetter} from '../../../../../../helpers/functions';
import { FormWrapperInputComponent } from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import Input from '../../../../common/component/Input';
import DEFINE, { CAMPAIGN as CAMPAIGN_ENUM, DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import { Col, Row, Checkbox, Icon, Radio } from 'antd';
import { toArray, values, cloneDeep } from 'lodash';
import './styles.less';
import moment from 'moment';

const CheckboxGroup = Checkbox.Group;

const PromotionMarkup = ({ ...props }) => {
    const {
        t,
        campaign,
        campaignState,
        onChangeCampaignMarkup
    } = props;

    const { markupConfig, markupFlys, markupBundleMinValue, isFetchingLoad } = campaignState;
    const campaignProps = campaignState.detail.campaign;

    const [markupCampaignId, setMarkupCampaignId] = useState([]);
    const [markupCampaignData, setMarkupCampaignData] = useState([]);
    const [holtelCollapse, setHoltelCollapse] = useState([]);
    const [isTypeDiscount, setIsTypeDiscount] = useState(false);

    useEffect(()=>{
        function loadData(){
            if(campaign.productType && campaign.productType.length > 0 && campaign.discountType){
                props.getMarkupPromotionConfig({markupProductType: campaign.productType[0] === 'MARKUP_BUNDLE' ? 2 : 1, 
                markupType: campaign.discountType === CAMPAIGN_ENUM.DISCOUNT_TYPE['AMOUNT'].id ?  0 : 1})
                props.getMarkupPromotionFly();
                setMarkupCampaignId([])
                setIsTypeDiscount(false)
            }
        }
        loadData()
    }, [campaign.productType, campaign.discountType]);

    useEffect(()=>{
        if(campaignProps && Object.keys(campaignProps).length > 0){
            const { markupCampaigns } = campaignProps.promotionMarkup;
            if(markupCampaigns && markupCampaigns.length > 0){
                const markupCampaignIdTmp = markupCampaigns.map(item => {
                    return item.markupConfigId
                })
                setMarkupCampaignId(markupCampaignIdTmp)
            }
        }
    }, [campaignProps]);

    useEffect(()=>{
        if(campaignProps && Object.keys(campaignProps).length > 0){
            if(markupCampaignId && markupCampaignId.length > 0){
                const { markupConfig } = campaignState;
                if(markupConfig){
                    let markupConfigSelect = markupConfig.filter(item => markupCampaignId.includes(item.id));
                    const { markupCampaigns } = campaignProps.promotionMarkup;
                    if(markupCampaigns && markupCampaigns.length > 0){
                        markupConfigSelect = markupConfigSelect.map(item => {
                            const indexItem = markupCampaigns.find(it => it.markupConfigId === item.id)
                            return indexItem ? {
                                ...item,
                                hotelConfigs: indexItem.hotelConfigs
                            } : item
                        })
                    }
                    setMarkupCampaignData(markupConfigSelect)
                }
            }else{
                setMarkupCampaignData([])
            }
        }
    }, [markupCampaignId, campaignState.markupConfig]);

    useEffect(()=>{
        props.getMarkupBundleMinValue(markupCampaignId)
    }, [markupCampaignId]);

    useEffect(()=>{
        if(markupCampaignData && markupCampaignData.length > 0){
            const newTransferCampaignData = markupCampaignData.filter(item => item.hotelConfigs && item.hotelConfigs.length > 0).map(item => {
                return{
                    hotelConfigs: item.hotelConfigs,
                    markupConfigId: item.id,
                    markupConfigName: item.name
                }
            })
            onChangeCampaignMarkup('markupCampaigns', newTransferCampaignData);
        }else{
            onChangeCampaignMarkup('markupCampaigns', []);
        }
    }, [markupCampaignData]);

    useEffect(()=>{
        if(markupCampaignData && markupCampaignData.length > 0 && campaign.discountType && campaign.productType){
            if(campaign.discountType === CAMPAIGN_ENUM.DISCOUNT_TYPE['AMOUNT'].id){
                if(campaign.productType[0] === 'MARKUP_BUNDLE'){
                    const isCheckTmp = markupCampaignData.every(item => item.markupFlightValue === 0)
                    if(isCheckTmp){
                        setIsTypeDiscount(true)
                    }
                }else{
                    setIsTypeDiscount(true)
                }
            }
        }else{
            setIsTypeDiscount(false)
        }
    }, [markupCampaignData, campaign.discountType, campaign.productType]);

    // const onChangeMarkupCampaign = (data)=>{
    //     const { markupConfig } = campaignState;
    //     setMarkupCampaignId(data);
    //     const markupConfigSelect = markupConfig.filter(item => data.includes(item.id));
    //     setMarkupCampaignData(markupConfigSelect)
    // }

    const checkHotelSelect = (value, index, idx, hotelId)=> {
        const convertMarkupCampaignData = cloneDeep(markupCampaignData)
        if(value){
            convertMarkupCampaignData[index].hotelConfigs = [...convertMarkupCampaignData[index].hotelConfigs || [], convertMarkupCampaignData[index].ratePlanConfigs[idx]]
        }else{
            convertMarkupCampaignData[index].hotelConfigs = convertMarkupCampaignData[index].hotelConfigs.filter(item => item.hotelId !== hotelId)
        }
        setMarkupCampaignData([...convertMarkupCampaignData])
    }

    const onOpenCollapse = (markupId, id, actionType)=> {
        if(actionType === 'open'){
            setHoltelCollapse([...holtelCollapse, `${markupId}:${id}`])
        }else{
            setHoltelCollapse(holtelCollapse.filter(item => item !== `${markupId}:${id}`))
        }
    }

    const onSelectRateHotel = (list, index, hotelId, currentList)=>{
        const convertMarkupCampaignData = cloneDeep(markupCampaignData)
        if(currentList.length > 0){
            let currentHotel = cloneDeep(convertMarkupCampaignData[index].ratePlanConfigs).find(item => item.hotelId === hotelId)
            if(list.length === 0){
                const findIndexItem = convertMarkupCampaignData[index].hotelConfigs.findIndex(item => item.hotelId === hotelId)
                if(findIndexItem > -1){
                    convertMarkupCampaignData[index].hotelConfigs.splice(findIndexItem, 1)
                }
            }else{
                currentHotel.ratePlans = currentList.filter(item => list.includes(item.ratePlanId))
                let findIndexItem = -1;
                if(convertMarkupCampaignData[index].hotelConfigs && convertMarkupCampaignData[index].hotelConfigs.length > 0){
                    findIndexItem = convertMarkupCampaignData[index].hotelConfigs.findIndex(item => item.hotelId === hotelId)
                    if(findIndexItem > -1){
                        convertMarkupCampaignData[index].hotelConfigs[findIndexItem] = currentHotel
                    }
                }
                if(findIndexItem < 0){
                    convertMarkupCampaignData[index].hotelConfigs = [...convertMarkupCampaignData[index].hotelConfigs || [], currentHotel || []]
                }
            }
            
            setMarkupCampaignData([...convertMarkupCampaignData])
        }
    }

    return(
        <Wrapper className="row">
            <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                    // dataValidation={ campaign.channel }
                    // validation={ validation.channel }
                    messageBelowInput={ true }
                    labelTitle={t("item.campaign.promotionMarkup.markupCampaigns")}
                >
                    <AntSelect className="select-types"
                            showArrow
                            mode="multiple"
                            placeholder={ capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.campaign.channel")).toLowerCase()) }
                            value={ markupCampaignId }
                            onChange={ markupCampaign => setMarkupCampaignId(markupCampaign) }
                            style={ { width: '100%' } }
                    >
                        { (markupConfig || []).map(conf => (
                            <AntOption key={ conf.id } value={ conf.id }>
                                { conf.name }
                            </AntOption>
                        )) }
                    </AntSelect>
                </FormWrapperInputComponent>
            </Wrapper>
            {
                campaign.productType[0] === 'MARKUP_BUNDLE' && 
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        // dataValidation={ campaign.channel }
                        // validation={ validation.channel }
                        messageBelowInput={ true }
                        labelTitle={t("item.campaign.promotionMarkup.airlineCodes")}
                    >
                        <AntSelect className="select-types"
                                showArrow
                                mode="multiple"
                                placeholder={ capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.campaign.channel")).toLowerCase()) }
                                value={ campaign.promotionMarkup.airlineCodes }
                                onChange={ airlines => onChangeCampaignMarkup('airlineCodes', airlines) }
                                style={ { width: '100%' } }
                        >
                            { (markupFlys || []).map(fly => (
                                <AntOption key={ fly.id } value={ fly.id }>
                                    <img width={30} alt="" src={fly.imageUrl} />&nbsp;{ `${fly.id} - ${fly.name}`}
                                </AntOption>
                            )) }
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
            }
            <Wrapper className="col-md-12">
                <Row>
                    <Col span={6}>
                        <b>Campaign</b>
                    </Col>
                    <Col span={6}>
                        <b>Staydate</b>
                    </Col>
                    <Col span={6}>
                        <b>Bookdate</b>
                    </Col>
                    <Col span={6}>
                        <b>Hotel/RateCode</b>
                    </Col>
                </Row>
                <Row style={{ borderBottom: '1px solid #919aa0', marginBottom: 10, marginTop: 5 }} />
                {
                    (markupCampaignData || []).map((item, index) => {
                        return (
                            <Row key={item.id} >
                                <Col span={6}>
                                    <span>{item.name}</span>
                                </Col>
                                <Col span={6}>
                                    <span>{ moment(item.stayDateFrom).format(DATE_TIME_FORMAT.SHORT_DATE) } - { moment(item.stayDateTo).format(DATE_TIME_FORMAT.SHORT_DATE) }&nbsp;&nbsp;{Func.formatMoney(item.markupValue)}</span>
                                </Col>
                                <Col span={6}>
                                    {
                                        item.bookDates && (item.bookDates || []).map(item => {
                                            return (
                                                <div key={item.id}>
                                                    {moment(item.bookDateFrom).format(DATE_TIME_FORMAT.SHORT_DATE) } - { moment(item.bookDateTo).format(DATE_TIME_FORMAT.SHORT_DATE)}&nbsp;&nbsp;{Func.formatMoney(item.markupValue)}
                                                </div>
                                            )
                                        })
                                    }
                                </Col>
                                <Col span={6}>
                                    {
                                        (item.ratePlanConfigs || []).map( (it, idx) => {
                                            return (
                                                <div key={it.hotelId} style={{marginTop: idx > 0 ? 10 : 0}}>
                                                    <div style={{ borderBottom: '1px solid #E9E9E9', marginBottom: 10 }}>
                                                        <Checkbox
                                                            onChange={(e)=> checkHotelSelect(e.target.checked, index, idx, it.hotelId)}
                                                            checked={markupCampaignData && markupCampaignData.length > 0 && markupCampaignData[index].hotelConfigs &&
                                                                markupCampaignData[index].hotelConfigs && 
                                                                (markupCampaignData[index].hotelConfigs || []).filter(check => check.hotelId === it.hotelId).length > 0}
                                                        >
                                                            {it.hotelName}
                                                        </Checkbox>
                                                        {!holtelCollapse.includes(`${item.id}:${it.hotelId}`) ? <Icon className="icon-collaps" type="down" onClick={()=> onOpenCollapse(item.id, it.hotelId, 'open')}/>
                                                         : <Icon className="icon-collaps" type="up" onClick={()=> onOpenCollapse(item.id, it.hotelId, 'close')}/>}
                                                    </div>
                                                    {
                                                        holtelCollapse.includes(`${item.id}:${it.hotelId}`) && 
                                                        <CheckboxGroup
                                                            className="checkbox-collaps"
                                                            options={(it.ratePlans || []).map(i => {
                                                                return{
                                                                    label: i.ratePlanCode,
                                                                    value: i.ratePlanId

                                                                }
                                                            })}
                                                            value={((markupCampaignData[index].hotelConfigs && markupCampaignData[index].hotelConfigs.length > 0) 
                                                                ? markupCampaignData[index].hotelConfigs.find(markup => markup.hotelId === it.hotelId)?.ratePlans || [] : []).map(item => item.ratePlanId)}
                                                            onChange={(list)=> onSelectRateHotel(list, index, it.hotelId, it.ratePlans)}
                                                        />
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </Col>
                                <Col span={24} style={{ borderBottom: '1px solid #919aa0', marginBottom: 10, marginTop: 10 }}></Col>
                            </Row>
                        )
                    })
                }
                
            </Wrapper>
            <Wrapper className="col-md-12">
                <FormWrapperInputComponent>
                    <span>Markup thấp nhất:</span> <b>{isFetchingLoad ? <Icon type="loading"/> : Func.formatMoney(markupBundleMinValue >= 0 ? markupBundleMinValue : 0)} {campaign.discountType === CAMPAIGN_ENUM.DISCOUNT_TYPE['AMOUNT'].id ? 'VND' : '%'}</b> 
                </FormWrapperInputComponent>
            </Wrapper>
            {
                isTypeDiscount &&  
                <Wrapper className="col-md-12">
                    <FormWrapperInputComponent
                        // dataValidation={ campaign.channel }
                        // validation={ validation.channel }
                        messageBelowInput={ true }
                        labelTitle={t("item.campaign.promotionMarkup.isMultipleRoomNight")}
                    >
                        <Wrapper style={{display: 'flex', marginBottom: 5}}>
                            <Wrapper className="col-md-4" style={{textAlign: 'left',padding: 0}}>
                                Số lượng phòng tìm kiếm để hưởng promotion
                                </Wrapper>
                                <Wrapper className="col-md-4">
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ t("item.campaign.promotionMarkup.minRoomNight") }
                                        className="form-control text-right" name="minRoomNight"
                                        onChange={ (e) => onChangeCampaignMarkup('minRoomNight', Number(e.target.value)) }
                                        value={ campaign.promotionMarkup.minRoomNight ? campaign.promotionMarkup.minRoomNight : '' }/>
                                </Wrapper>
                                <Wrapper className="col-md-4">
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ t("item.campaign.promotionMarkup.maxRoomNight") }
                                        className="form-control text-right" name="maxRoomNight"
                                        onChange={ (e) => onChangeCampaignMarkup('maxRoomNight', Number(e.target.value)) }
                                        value={ campaign.promotionMarkup.maxRoomNight ? campaign.promotionMarkup.maxRoomNight : '' }/>
                            </Wrapper>
                        </Wrapper>
                    <FormWrapperInputComponent>
                            <Radio.Group value={ campaign.promotionMarkup.isMultipleRoomNight} onChange={ e => onChangeCampaignMarkup('isMultipleRoomNight', e.target.value) }>
                                <Radio value={false}>Không nhân theo roomnight</Radio>
                                <Radio value={true}>Có nhân theo roomnight</Radio>
                            </Radio.Group>
                        </FormWrapperInputComponent>
                        { campaign.promotionMarkup.isMultipleRoomNight && <Wrapper className="row">
                                <Wrapper className="col-md-2" style={{textAlign: 'center'}}>
                                    Room night
                                </Wrapper>
                                <Wrapper className="col-md-5">
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ t("item.campaign.promotionMarkup.minRoomNight") }
                                        className="form-control text-right" name="minRoomNight"
                                        onChange={ (e) => onChangeCampaignMarkup('minRoomNight', Number(e.target.value)) }
                                        value={ campaign.promotionMarkup.minRoomNight ? campaign.promotionMarkup.minRoomNight : '' }/>
                                </Wrapper>
                                <Wrapper className="col-md-5">
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ t("item.campaign.promotionMarkup.maxRoomNight") }
                                        className="form-control text-right" name="maxRoomNight"
                                        onChange={ (e) => onChangeCampaignMarkup('maxRoomNight', Number(e.target.value)) }
                                        value={ campaign.promotionMarkup.maxRoomNight ? campaign.promotionMarkup.maxRoomNight : '' }/>
                                </Wrapper>
                            </Wrapper>
                        }
                    </FormWrapperInputComponent>
                    <FormWrapperInputComponent
                        // dataValidation={ campaign.channel }
                        // validation={ validation.channel }
                        messageBelowInput={ true }
                        // labelTitle={t("item.campaign.promotionMarkup.isMultipleRoomNight")}
                        labelTitle={"Cách tính số phòng"}
                    >
                    <FormWrapperInputComponent>
                            <Radio.Group value={ campaign.promotionMarkup.isMultipleRoomNight} onChange={ e => onChangeCampaignMarkup('isMultipleRoomNight', e.target.value) }>
                                <Radio value={false}>Nhân theo room</Radio>
                                <Radio value={true}>Có nhân theo số lượng phòng ngủ</Radio>
                            </Radio.Group>
                        </FormWrapperInputComponent>
                        { campaign.promotionMarkup.isMultipleRoomNight && <Wrapper className="row">
                                <Wrapper className="col-md-2" style={{textAlign: 'center'}}>
                                    Phòng ngủ
                                </Wrapper>
                                <Wrapper className="col-md-5">
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ t("item.campaign.promotionMarkup.minRoomNight") }
                                        className="form-control text-right" name="minRoomNight"
                                        onChange={ (e) => onChangeCampaignMarkup('minRoomNight', Number(e.target.value)) }
                                        value={ campaign.promotionMarkup.minRoomNight ? campaign.promotionMarkup.minRoomNight : '' }/>
                                </Wrapper>
                                <Wrapper className="col-md-5">
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ t("item.campaign.promotionMarkup.maxRoomNight") }
                                        className="form-control text-right" name="maxRoomNight"
                                        onChange={ (e) => onChangeCampaignMarkup('maxRoomNight', Number(e.target.value)) }
                                        value={ campaign.promotionMarkup.maxRoomNight ? campaign.promotionMarkup.maxRoomNight : '' }/>
                                </Wrapper>
                            </Wrapper>
                        }
                    </FormWrapperInputComponent>
                </Wrapper>
            }
        </Wrapper>
    )
}

export default PromotionMarkup;